import React, { PureComponent } from 'react';
import Icon from '~/core/scripts/components/Icon';
// import SectionTitle from '~/kits/general/SectionTitle';

class MapLegend extends PureComponent {
  render() {
    const { items } = this.props;
    const filteredItems = items.filter(c => typeof c !== 'undefined');

    return (
      <div className="maplegend__wrapper">
        <div className="maplegend__title hd__title">
          <Icon type='mobile' />
          <div className="hd__title-text">
            <div className="hd__title-main">Deutsche Handy-Nutzer im EU-Ausland</div>
            <div className="hd__title-sub">plus Island, Liechtenstein, Norwegen</div>
          </div>
        </div>
        <div className="maplegend">
          <div className="maplegend__label start">weniger</div>
          <div className="maplegend__items">
          {filteredItems.map(c => (
            <div
              key={`maplegend__${c}`}
              className="maplegend__item"
              style={{ backgroundColor: c }}
            />
            ))}
          </div>
          <div className="maplegend__label end">mehr</div>
        </div>
      </div>
    );
  }
}

export default MapLegend;